import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const EmptyBar = styled.div`
  height: 28px;
  width: 100%;
  border-radius: 5px;
  background-color: #cccccc;
  overflow: hidden;
  position: relative;
`

const ProgressBar = styled.div`
  height: inherit;
  width: ${props => (props.progress.length < 1 ? '1px' : props.progress)}%;
  background: repeating-linear-gradient(
    50deg,
    #5b7990,
    #5b7990 24px,
    #4e6c84 24px,
    #4e6c84 46px
  );
  background-size: 60px 100%;
  transition: width 0.3s ease;
  animation: shift 2s linear infinite;

  @keyframes shift {
    to {
      background-position: 60px 100%;
    }
  }
`

const ProgressText = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 12px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
`

const FileUploadProgressBar = ({ progress }) => (
  <EmptyBar>
    <ProgressText>Uploading {progress}%</ProgressText>
    <ProgressBar progress={progress} />
  </EmptyBar>
)

FileUploadProgressBar.propTypes = {
  progress: PropTypes.number.isRequired
}

export default FileUploadProgressBar



// WEBPACK FOOTER //
// ./src/components/mini/FileUploadProgressBar.js